import { Box, Card, Checkbox, Chip, Dialog, FormControl, InputLabel, MenuItem, Button as MUIButton, Select, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  WithPermissions
} from 'react-admin';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AddressField from 'src/pages/admin/components/AddressField';
import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { Resources } from '../../resource';
import { Iconify } from 'src/components/iconify';
import CreateColor from './Create';
import EditColor from './Edit';
import { chains } from 'src/assets/data';


const ListFilter = (props: any) => {
  const { filterValues } = useListController();

  return (
    <Filter {...(props || {})}>
      {/* <FilterGroup alwaysOn spacing={0} p={0}>
        <FilterGroup>
          <XTextInput source="symbol" label="module.tokenMetadata.symbol" />
        </FilterGroup>
      </FilterGroup> */}
    </Filter>
  );
};

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  return (
    <PermissionGuard resource="colors" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.color')}
          links={[
            { name: translate('resource.configs'), href: '#' },
            { name: translate('resource.color'), href: `/${Resources.color}` },
            { name: translate('resource.list') },
          ]}
          action={
            <PermissionGuard resource="colors" action="create" fallback={<></>}>
                <CreateButton variant="contained" size='medium' onClick={(e)=> {
                  e.preventDefault()
                  setPopup(<CreateColor onClose={() => setPopup(undefined)} />)
                }} />
            </PermissionGuard>
          }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List filters={<ListFilter />} perPage={10} exporter={false} actions={false} empty={false}>
            <Box sx={{overflow: 'auto'}}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={
                  <PermissionButton resource="colors" action="delete">
                    <BulkDeleteButton />
                  </PermissionButton>
                }
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <TextField source='name' label="module.color.name" sortable={false}/>
                <TextField source='key' label="module.color.key" sortable={false}/>
                {/* <TextField source='color' label="module.color.color" sortable={false}/> */}
                <FunctionField
                  label="module.color.color"
                  render={record => (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box
                        sx={{
                          width: 16,
                          height: 16,
                          bgcolor: record.color || '#000000',
                          border: '1px solid #ccc',
                          borderRadius: 0.5,
                        }}
                      />
                      <span>{record.color}</span>
                    </Box>
                  )}
                  sortable={false}
                />

                <FunctionField
                  label="module.color.enable"
                  render={(record) =>
                    <Chip label={record.enable ? "True" : "False"} color={record.enable ? "success" : "error"} size="small" />
                  }
                  sortable={false}
                />

                <FunctionField
                  render={(record: any) => (
                    <Stack direction="row" spacing={2}>
                      <PermissionGuard resource="colors" action="update" fallback={<></>}>
                        <EditButton onClick={(e)=> {
                          e.preventDefault()
                          setPopup(<EditColor id={record.id} onClose={() => setPopup(undefined)} />)
                        }} />
                      </PermissionGuard>
                      <PermissionGuard resource="colors" action="delete" fallback={<></>}>
                        <DeleteButton
                          mutationMode="pessimistic"
                        />
                      </PermissionGuard>
                    </Stack>
                  )}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="sm" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;